"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.money = exports.Money = exports.PRESENTATION_SCALE = exports.MONEY_SCALE = void 0;
const decimal_js_1 = require("decimal.js");
/** دقة التخزين الداخلية — تطابق numeric(20,4) فى قاعدة البيانات. */
exports.MONEY_SCALE = 4;
/** دقة العرض والتقريب النهائى للمستندات (الجنيه/القرش). */
exports.PRESENTATION_SCALE = 2;
const ROUNDING = {
    half_up: decimal_js_1.Decimal.ROUND_HALF_UP,
    half_even: decimal_js_1.Decimal.ROUND_HALF_EVEN,
    down: decimal_js_1.Decimal.ROUND_DOWN,
};
decimal_js_1.Decimal.set({ precision: 34, toExpNeg: -9e15, toExpPos: 9e15 });
/**
 * مبلغ مالى غير قابل للتغيير. المال لا يُحسب أبدًا بـ `number`:
 * كل العمليات تمر على Decimal بدقة محددة وسياسة تقريب صريحة.
 */
class Money {
    value;
    constructor(value) {
        this.value = value;
    }
    static of(input) {
        if (input instanceof Money)
            return input;
        if (typeof input === 'number') {
            if (!Number.isFinite(input))
                throw new TypeError(`Money.of: non-finite number ${input}`);
            // رقم عشري عائم يدخل مرة واحدة فقط عند الحدود، ثم يصبح Decimal
            return new Money(new decimal_js_1.Decimal(input.toString()));
        }
        const d = input instanceof decimal_js_1.Decimal ? input : new decimal_js_1.Decimal(input);
        if (!d.isFinite())
            throw new TypeError(`Money.of: non-finite value ${String(input)}`);
        return new Money(d);
    }
    static zero() {
        return new Money(new decimal_js_1.Decimal(0));
    }
    static sum(items) {
        return items.reduce((acc, item) => acc.add(item), Money.zero());
    }
    add(other) {
        return new Money(this.value.plus(Money.of(other).value));
    }
    sub(other) {
        return new Money(this.value.minus(Money.of(other).value));
    }
    mul(factor) {
        return new Money(this.value.times(Money.of(factor).value));
    }
    div(divisor) {
        const d = Money.of(divisor).value;
        if (d.isZero())
            throw new RangeError('Money.div: division by zero');
        return new Money(this.value.dividedBy(d));
    }
    negate() {
        return new Money(this.value.negated());
    }
    abs() {
        return new Money(this.value.abs());
    }
    /** تقريب صريح — لا يوجد تقريب ضمنى فى أى مكان آخر. */
    round(scale = exports.PRESENTATION_SCALE, mode = 'half_up') {
        return new Money(this.value.toDecimalPlaces(scale, ROUNDING[mode]));
    }
    /** تطبيع إلى دقة التخزين قبل المقارنة أو الحفظ. */
    normalize() {
        return this.round(exports.MONEY_SCALE, 'half_even');
    }
    isZero() {
        return this.value.isZero();
    }
    isNegative() {
        return this.value.isNegative() && !this.value.isZero();
    }
    isPositive() {
        return this.value.isPositive() && !this.value.isZero();
    }
    cmp(other) {
        return this.value.comparedTo(Money.of(other).value);
    }
    eq(other) {
        return this.cmp(other) === 0;
    }
    gt(other) {
        return this.cmp(other) > 0;
    }
    gte(other) {
        return this.cmp(other) >= 0;
    }
    lt(other) {
        return this.cmp(other) < 0;
    }
    /** نص قابل للحفظ فى numeric(20,4) — بلا صيغة علمية. */
    toString() {
        return this.value.toDecimalPlaces(exports.MONEY_SCALE, decimal_js_1.Decimal.ROUND_HALF_EVEN).toFixed(exports.MONEY_SCALE);
    }
    toFixed(scale = exports.PRESENTATION_SCALE, mode = 'half_up') {
        return this.value.toDecimalPlaces(scale, ROUNDING[mode]).toFixed(scale);
    }
    toJSON() {
        return this.toString();
    }
    toDecimal() {
        return this.value;
    }
}
exports.Money = Money;
exports.money = Money.of;
//# sourceMappingURL=money.js.map